import React from 'react';
import { Link } from 'react-router-dom';

const ArticleHeaderSection = ({
  author,
  dateLabel,
  minutes,
  publishedAt,
  summary,
  tags,
  title,
}) => {
  return (
    <section aria-labelledby="article-title" className="site-bg-hero py-16 px-6">
      <div className="container mx-auto max-w-3xl">
        <nav className="mb-4 text-sm text-gray-500">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <span className="mx-2">/</span>
          <Link to="/blog/artigos" className="hover:underline">
            Artigos
          </Link>
        </nav>

        <h1
          id="article-title"
          className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
        >
          {title}
        </h1>
        {summary && <p className="mt-4 text-lg text-gray-600">{summary}</p>}
        <div className="mt-4 flex flex-wrap items-center gap-3 text-sm text-gray-500">
          <span>Por {author}</span>
          {dateLabel && publishedAt && (
            <>
              <span aria-hidden="true">&middot;</span>
              <time dateTime={publishedAt}>{dateLabel}</time>
            </>
          )}
          {minutes && (
            <>
              <span aria-hidden="true">&middot;</span>
              <span>{minutes} min de leitura</span>
            </>
          )}
        </div>
        {tags.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-2">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ArticleHeaderSection;
